import type { LoginFormValues } from "@/lib/schemas/auth.schema"
import { apiClient, type AuthResponse, type AuthResponseEnvelope } from "@/lib/api/http"

export async function loginUser(credentials: LoginFormValues): Promise<AuthResponse> {
  const isAdmin = credentials.role === "ADMIN"
  // Backend returns: { success, statusCode, message, data: { user, accessToken, refreshToken }, meta }
  const { data: envelope } = await apiClient.post<AuthResponseEnvelope>("/auth/sign-in/email", {
    email: credentials.email,
    password: credentials.password,
    accountType: isAdmin ? "ADMIN" : "USER",
    ...(isAdmin ? {} : { role: credentials.role }),
  })

  // Unwrap the nested data envelope into a flat AuthResponse
  return {
    accessToken: envelope.data.accessToken,
    refreshToken: envelope.data.refreshToken,
    user: envelope.data.user,
  }
}

export async function signOut(accessToken: string, refreshToken: string): Promise<void> {
  try {
    await apiClient.post(
      "/auth/sign-out",
      { refreshToken },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )
  } catch {
    // Silently ignore sign-out errors — we clear local state regardless
  }
}